export default __webpack_public_path__ + "b46f5f630d72bb11b1a5aa6a80fc8c4c.jpg";